import './FrmKontakt.css';
import React, { useRef, useState } from 'react';

function FrmKontakt (props) {

    // const url = 'http://mm.ciscoskolenia.eu/engine/ws/kontakt/?do=add';
    const url = 'https://www.ciscoskolenia.eu/engine/ws/kontakt/?do=add';
    // const aktPoziadavka = props.aktPoziadavka;
    const aktReferral = 'cseu-servis-a-sprava';

    const menoRef = useRef('');
    const mailRef = useRef('');
    const mobilRef = useRef('');

    const [povolitSubmit, setPovolitSubmit] = useState(false);

    var formular = {
        meno: menoRef.current.value,
        mail: mailRef.current.value,
        mobil: mobilRef.current.value,
        poziadavka: "",
        ref: aktReferral
    }

    function naplnUdajeFormularu() {
        formular.meno = menoRef.current.value;
        formular.mail = mailRef.current.value;
        formular.mobil = mobilRef.current.value;
        formular.poziadavka = document.getElementById('hdnPoziadavka').value;
        formular.ref = document.getElementById("lit-frm-ref").innerHTML;
        console.log("ref:", formular.ref);
    }

    const btnPotvrditClickHandler = () => {

        naplnUdajeFormularu();

        fetch(url, {
            method: 'POST',
            body: JSON.stringify(formular), //JSON.stringify(formularPokus), //JSON.stringify(formular),
            headers: {
                // (takto spracuje $_POST PHP, ale potom treba https://stackoverflow.com/questions/35325370/how-do-i-post-a-x-www-form-urlencoded-request-using-fetch)
                // 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',      
                'Content-Type': 'application/json; charset=UTF-8',
            }
        }).then((response) => {
                response = response.json();
                 alert(props.formdata.alertok);
             }
        ).catch((error) => {
                alert(props.formdata.alerterr);
            }
        );

    }

    /**
     * Zmysel tejto metody je to, aby sa formular automaticky neodosielal 
     * (a teda aj nerefreshla stranka)ked sa stlaci button, lebo mame na to vlasny kod.
     */
    function submitHandler(event) {
        event.preventDefault();
    }

    function pridajZavinac() {
        let inputValue = mailRef.current.value;

        if (inputValue.length === 0) {
            mailRef.current.value = "@";
        }

    }

    function nastavMobil() {
        const frmCastEmail = document.getElementById('lit-frm-cast-email');
        frmCastEmail.style.display = 'none';
        const frmCastMobil = document.getElementById('lit-frm-cast-mobil');
        frmCastMobil.style.display = 'block';
        setPovolitSubmit(true);
    }

    function nastavEmail() {
        const frmCastMobil = document.getElementById('lit-frm-cast-mobil');
        frmCastMobil.style.display = 'none';
        const frmCastEmail = document.getElementById('lit-frm-cast-email');
        frmCastEmail.style.display = 'block';
        setPovolitSubmit(true);
    }

    return (<div>

        <form className="lit-frm-kontakt" onSubmit={submitHandler}>

        <div className="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true"> 
            <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content"> 
                    <div className="modal-header">
                        <h4 id="lit-frm-mod-tit" className="modal-title">Kontakt</h4>
                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button> 
                    </div>  
                    <div className="modal-body"> 

                        <p>{props.formdata.nadpis}</p>
                        
                        <div className="text-center">
                            <div className="btn-group" role="group">
                                <input type="radio" className="btn-check" name="btnradio" id="rbtnMobil" autocomplete="off" onClick={() => nastavMobil()} />
                                <label className="btn btn-outline-primary" for="rbtnMobil">{props.formdata.mobil}</label>

                                <input type="radio" className="btn-check" name="btnradio" id="rbtnEmail" autocomplete="off" onClick={() => nastavEmail()} />
                                <label className="btn btn-outline-primary" for="rbtnEmail">{props.formdata.mail}</label>
                            </div>
                        </div>

                        <div className="form-group">
                            <label htmlFor="txtMeno">{props.formdata.meno}</label>
                            <input type="text" className="form-control" id="txtMeno" placeholder={props.formdata.meno.toLowerCase()} ref={menoRef} />
                        </div>

                        <div id="lit-frm-cast-email" className="form-group">
                            <label htmlFor="txtMail">Email</label>
                            <input type="email" className="form-control" id="txtMail" placeholder="email" ref={mailRef} onClick={pridajZavinac} />
                        </div>


                        <div id="lit-frm-cast-mobil" className="form-group">
                            <label htmlFor="txtMobil">Mobil</label>
                            <input type="text" className="form-control" id="txtMobil" placeholder="mobil" ref={mobilRef} />
                        </div>

                    </div>
                    <div className="modal-footer">
                        <button id="lit-frm-submit" className="btn btn-primary" onClick={btnPotvrditClickHandler} data-dismiss="modal" disabled={!povolitSubmit}>{props.formdata.dokonc}</button>
                    </div>
                </div>
            </div>
        </div>
        <input type="hidden" id="hdnPoziadavka" name="hdnPoziadavka" value=" "/>
        </form>
    </div>
    ); 
}

export default FrmKontakt;